import { Suspense, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import { PlanAndFeaturesWrapper, Wrapper } from './index.styles';

import LoadingText from '../../../loading_text';
import BeginTrialButton from './begin_trial_button';
import ChoosePlan from './choose_plan';
import YoullReceive from './youll_receive';

import { plansState } from '../../../../store';

import type { Plan } from '@rewardopl/types';

const sortByMaxPlaces = (a: Plan, b: Plan) => (a.max_places || 0) - (b.max_places || 0);

export default function OnboardingPlan() {
  const navigate = useNavigate();
  const plans = useAtomValue(plansState);

  const plansSortedByMaxPlaces = [...plans].sort(sortByMaxPlaces);

  const firstPlan = plansSortedByMaxPlaces[0];

  if (!firstPlan) {
    throw new Error('No plans found');
  }

  const [planId, setPlanId] = useState(firstPlan._id);

  function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    navigate('../details', {
      state: {
        planId,
      },
    });
  }

  return (
    <Wrapper>
      <h1>
        <T>Register</T>
      </h1>
      <Suspense fallback={<LoadingText />}>
        <form onSubmit={onSubmit}>
          <PlanAndFeaturesWrapper>
            <ChoosePlan onChange={setPlanId} value={planId} />
            <YoullReceive />
          </PlanAndFeaturesWrapper>
          <BeginTrialButton />
        </form>
      </Suspense>
    </Wrapper>
  );
}
